import request from '../request';

export default {
  //小程序-列表
  lists(data) {
    return request.get('/adminShop/index', data);
  },

  //小程序-添加
  add(data) {
    return request.post('/adminShop/create', data);
  },

  //小程序-修改
  edit(data) {
    return request.post('/adminShop/update', data);
  },

  //小程序-删除
  delete(data) {
    return request.post('/adminShop/delete', data);
  },
};
